import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';

import {
    ButtonBase,
    MenuList,
    MenuItem,
    Popper,
    Grow,
    Typography,
    ClickAwayListener,
    Avatar,
    makeStyles
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import { updateUser } from '../../redux/user/Actions';

const useStyles = makeStyles(theme => styles(theme));

function Profile () {
    const classes = useStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    // const authenticity_token = document
    //     .querySelector("meta[name='csrf-token']")
    //     .getAttribute('content');

    const [anchorEl, setAnchorEl] = useState(null);

    const user = useSelector(state => state.user);
    const lastActivation = useSelector(state => state.user.lastActivation);

    const name = `${user.firstName} ${user.lastName}`;

    function handleClick (event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose () {
        setAnchorEl(null);
    }

    function goToPage (page) {
        history.push(page);
    }

    async function submitLogout () {
        // const searchParams = new URLSearchParams({
        //     authenticity_token: authenticity_token,
        //     utf8: '✓'
        // });
        // fetch('/user/logout', {
        //     method: 'DELETE',
        //     body: searchParams.toString(),
        //     headers: {
        //         'content-type': 'application/x-www-form-urlencoded'
        //     }
        // })
        //     .then(res => {
        //         window.location.replace('/user/login');
        //     })
        //     .catch(err => console.error(err));
        try {
            await axios.delete('/user/logout', {});
        } catch (error) {
            console.error(error);
        } finally {
            window.location.replace('/user/login');
        }
    }

    function subscriptionText () {
        if (lastActivation) {
            if (lastActivation.isExpired) {
                return 'Expired';
            } else if (lastActivation.isActive) {
                return lastActivation.product.name;
            }
        }
        return 'Inactive';
    }

    useEffect(() => {
        const checkAvatarUrl = () => {
            axios
                .get(user?.avatar, { responseType: 'blob' })
                .then(response => {
                    if (response.data.size > 0) dispatch(updateUser({ avatar: user?.avatar }));
                    else dispatch(updateUser({ avatar: '' }));
                })
                .catch(() => {
                    dispatch(updateUser({ avatar: '' }));
                });
        };
        checkAvatarUrl();
    }, []);

    return (
        <div className={classes.root}>
            <ButtonBase className={classes.button} onClick={handleClick}>
                {user?.avatar ? (
                    <img
                        src={user?.avatar}
                        alt="profile_avatar"
                        className={classes.profilePicture}
                    />
                ) : (
                    <Avatar alt={name} className={classes.avatar}>
                        {name.charAt(0)}
                    </Avatar>
                )}

                <div className={classes.b}>
                    <Typography align="left" variant="body1" color="textPrimary">
                        {name}
                        {anchorEl ? (
                            <ArrowDropUpIcon className={classes.chevron} />
                        ) : (
                            <ArrowDropDownIcon className={classes.chevron} />
                        )}
                    </Typography>
                    <Typography align="left" variant="caption" color="textPrimary">
                        {subscriptionText()}{' '}
                        {lastActivation && lastActivation.trial && (
                            <span className={classes.trial}>TRIAL</span>
                        )}
                    </Typography>
                </div>
            </ButtonBase>
            <Popper
                className={classes.popper}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                placement="bottom"
                transition
                disablePortal>
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps}>
                        <div className={classes.d}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList
                                    className={classes.menu}
                                    autoFocusItem={Boolean(anchorEl)}
                                    id="menu-list-grow">
                                    {/* <MenuItem onClick={this.handleClose}>Profile</MenuItem> */}
                                    {/* <MenuItem onClick={this.handleClose}>My account</MenuItem> */}
                                    <MenuItem
                                        className={classes.menuItem}
                                        onClick={() => goToPage('/preferences')}>
                                        Preferences
                                    </MenuItem>
                                    <MenuItem onClick={() => goToPage('/profile')}>
                                        Profile
                                    </MenuItem>
                                    <MenuItem onClick={submitLogout}>Logout</MenuItem>
                                </MenuList>
                            </ClickAwayListener>
                        </div>
                    </Grow>
                )}
            </Popper>
        </div>
    );
}

const WIDTH = 230;
const styles = theme => ({
    root: {
        width: WIDTH,
        height: '100%',
        display: 'flex',
        position: 'relative',
        padding: `0px ${theme.constants.spacing.lg}px`,
        boxSizing: 'border-box'
    },
    avatar: {
        width: theme.constants.headerContent,
        height: theme.constants.headerContent,
        boxSizing: 'border-box',
        borderRadius: '50%',
        border: `1px solid ${theme.palette.secondary.main}`,
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.primary.light
        // backgroundColor: `#${Math.floor(Math.random() * 0xFFFFFF).toString(16)}`
    },
    profilePicture: {
        height: theme.constants.headerContent,
        width: theme.constants.headerContent,
        borderRadius: '50%'
    },
    button: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    b: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '8px'
    },
    chevron: {
        position: 'absolute',
        right: '-24px',
        color: theme.palette.background.contrastText
    },
    popper: {
        zIndex: theme.zIndex.popover,
        width: WIDTH,
        transform: 'translate3d(0px, 57px, 0px) !important'
    },
    d: {
        backgroundColor: theme.palette.primary.main,
        padding: '0px 12px',
        boxSizing: 'border-box'
    },
    trial: {
        color: theme.palette.secondary.main
    },
    menu: {
        paddingTop: 0,
        paddingBottom: 0,
        '& > *': {
            padding: 0,
            height: 37,
            borderTop: `1px solid ${theme.palette.grey.variant5}`,
            color: theme.palette.background.contrastText,
            ...theme.typography.li
        },
        '& .MuiListItem-button:hover': {
            textDecoration: 'none',
            background: '#ffffff29'
        }
    }
});

export default Profile;
